import { render, staticRenderFns } from "./Chen.vue?vue&type=template&id=5311988a&scoped=true"
import script from "./Chen.vue?vue&type=script&lang=js"
export * from "./Chen.vue?vue&type=script&lang=js"
import style0 from "./Chen.vue?vue&type=style&index=0&id=5311988a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5311988a",
  null
  
)

export default component.exports